<template>
  <div class="nar-bar-box clearfix">
    <section class="nar-bar-box_left">
      <router-link :to="{ path: '/homeMain/workbench/workbench' }">
        <img src="@static/logo.png" class="storeLogo" alt="" />
      </router-link>
      <p class="admincp-name">商家运营中心</p>
    </section>

    <!-- <div class="header_title">商家运营中心</div> -->
    <section class="nar-bar-box_right clearfix">
      <div class="breadcrumb">
        <Breadcrumb>
          <i class="local"></i>
          <span>当前位置：</span>
          <BreadcrumbItem
            v-for="(item, index) in $attrs.breadData"
            :key="index"
            >{{ item }}</BreadcrumbItem
          >
        </Breadcrumb>
      </div>
      <div class="admincp-header-r">
        <ul class="operate nc-row">
          <li>
            <a
              @click="logOut"
              class="login-out show-option"
              title="安全退出管理中心"
            >
              <Icon type="power" size="20"></Icon>
            </a>
          </li>
        </ul>
      </div>
      <div class="picture">
        <img src="@static/login_userHead.png" alt="" />
        <span>{{ userName.substring(0, 4) + "..." }}</span>
      </div>

      <!-- <img class="header_userImg" src="../../../static/login_userHead.png" alt="">
			<span>{{userName}}</span> -->
      <!-- <span @click.stop="sure_exit()"><Icon type="ios-arrow-down" class="header_icon cursor" ></Icon></span>

			<div class="header_exitModal" v-show="exitFlag">
				<div class="sanjiao"></div>
				<div @click="logOut()" class="power cursor">
					<Icon type="power"></Icon>
					退出登录
				</div>
			</div> -->
    </section>
  </div>
</template>
<script>
// import { cookie } from '@/common'
export default {
  name: "Nav",
  created() {},
  data() {
    return {
      userName: "",
      exitFlag: false,
    };
  },
  methods: {
    sure_exit() {
      this.exitFlag = !this.exitFlag;
    },
    logOut() {
        sessionStorage.clear()
        //sessionStorage.removeItem("userLoginId");
        location.reload()
        //   this.$router.push("/");
    },
  },
  mounted() {
    this.userName = sessionStorage.getItem("userName");
    document.addEventListener("click", (e) => {
      if (!this.$el.contains(e.target)) this.exitFlag = false;
    });
  },
  watch: {
    $route(to, from) {
      this.userName = sessionStorage.getItem("userName");
    },
  },
};
</script>

<style scoped lang="less">
@import "./header.less";
</style>


// WEBPACK FOOTER //
// src/components/header/index.vue